import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postV2AdminNotesWorkflowsEditNote: build.mutation<
      PostV2AdminNotesWorkflowsEditNoteApiResponse,
      PostV2AdminNotesWorkflowsEditNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notes-workflows/edit-note`,
        method: "POST",
        body: queryArg.editNoteRequest,
      }),
    }),
    getV2AdminNotesWorkflowsStatusByTaskId: build.query<
      GetV2AdminNotesWorkflowsStatusByTaskIdApiResponse,
      GetV2AdminNotesWorkflowsStatusByTaskIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notes-workflows/status/${queryArg.taskId}`,
      }),
    }),
    getV2AdminNotesByNoteId: build.query<
      GetV2AdminNotesByNoteIdApiResponse,
      GetV2AdminNotesByNoteIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/notes/${queryArg.noteId}` }),
    }),
    postV2AdminNotesByNoteIdGeneratePdf: build.mutation<
      PostV2AdminNotesByNoteIdGeneratePdfApiResponse,
      PostV2AdminNotesByNoteIdGeneratePdfApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/notes/${queryArg.noteId}/generate-pdf`,
        method: "POST",
      }),
    }),
    getV2AdminProvidersByProviderIdNotes: build.query<
      GetV2AdminProvidersByProviderIdNotesApiResponse,
      GetV2AdminProvidersByProviderIdNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/providers/${queryArg.providerId}/notes`,
      }),
    }),
    postV2ProviderNoteGenerationCustomize: build.mutation<
      PostV2ProviderNoteGenerationCustomizeApiResponse,
      PostV2ProviderNoteGenerationCustomizeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-generation/customize`,
        method: "POST",
        body: queryArg.customizeModuleRequest,
      }),
    }),
    postV2ProviderNoteGenerationCustomizeApplyByThreadId: build.mutation<
      PostV2ProviderNoteGenerationCustomizeApplyByThreadIdApiResponse,
      PostV2ProviderNoteGenerationCustomizeApplyByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-generation/customize/apply/${queryArg.threadId}`,
        method: "POST",
        body: queryArg.applyCustomizationRequest,
      }),
    }),
    getV2ProviderNoteGenerationCustomizeHistoryByThreadId: build.query<
      GetV2ProviderNoteGenerationCustomizeHistoryByThreadIdApiResponse,
      GetV2ProviderNoteGenerationCustomizeHistoryByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-generation/customize/history/${queryArg.threadId}`,
      }),
    }),
    postV2ProviderNoteGenerationGenerate: build.mutation<
      PostV2ProviderNoteGenerationGenerateApiResponse,
      PostV2ProviderNoteGenerationGenerateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-generation/generate`,
        method: "POST",
        body: queryArg.generateModuleTextRequest,
      }),
    }),
    getV2ProviderNoteGenerationStreamByThreadId: build.query<
      GetV2ProviderNoteGenerationStreamByThreadIdApiResponse,
      GetV2ProviderNoteGenerationStreamByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-generation/stream/${queryArg.threadId}`,
      }),
    }),
    getV2ProviderNoteProcessingWorkflowsStatusByThreadId: build.query<
      GetV2ProviderNoteProcessingWorkflowsStatusByThreadIdApiResponse,
      GetV2ProviderNoteProcessingWorkflowsStatusByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-processing-workflows/status/${queryArg.threadId}`,
      }),
    }),
    getV2ProviderNoteProcessingWorkflowsStreamByThreadId: build.query<
      GetV2ProviderNoteProcessingWorkflowsStreamByThreadIdApiResponse,
      GetV2ProviderNoteProcessingWorkflowsStreamByThreadIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/note-processing-workflows/stream/${queryArg.threadId}`,
      }),
    }),
    getV2ProviderNotes: build.query<
      GetV2ProviderNotesApiResponse,
      GetV2ProviderNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          organization_id: queryArg.organizationId,
          queue: queryArg.queue,
          completion_status: queryArg.completionStatus,
          search: queryArg.search,
          note_title_only: queryArg.noteTitleOnly,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          sort_order: queryArg.sortOrder,
          cosign_scope: queryArg.cosignScope,
          include_dismissed: queryArg.includeDismissed,
        },
      }),
    }),
    postV2ProviderNotesWorkflowsEditNote: build.mutation<
      PostV2ProviderNotesWorkflowsEditNoteApiResponse,
      PostV2ProviderNotesWorkflowsEditNoteApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes-workflows/edit-note`,
        method: "POST",
        body: queryArg.providerEditNoteRequest,
      }),
    }),
    getV2ProviderNotesWorkflowsStatusByTaskId: build.query<
      GetV2ProviderNotesWorkflowsStatusByTaskIdApiResponse,
      GetV2ProviderNotesWorkflowsStatusByTaskIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes-workflows/status/${queryArg.taskId}`,
      }),
    }),
    postV2ProviderNotesBulkCosign: build.mutation<
      PostV2ProviderNotesBulkCosignApiResponse,
      PostV2ProviderNotesBulkCosignApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/bulk-cosign`,
        method: "POST",
        body: queryArg.bulkCosignRequest,
      }),
    }),
    getV2ProviderNotesByNoteId: build.query<
      GetV2ProviderNotesByNoteIdApiResponse,
      GetV2ProviderNotesByNoteIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/provider/notes/${queryArg.noteId}` }),
    }),
    patchV2ProviderNotesByNoteId: build.mutation<
      PatchV2ProviderNotesByNoteIdApiResponse,
      PatchV2ProviderNotesByNoteIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}`,
        method: "PATCH",
        body: queryArg.updateNoteRequest,
      }),
    }),
    getV2ProviderNotesByNoteIdActionsSuggested: build.query<
      GetV2ProviderNotesByNoteIdActionsSuggestedApiResponse,
      GetV2ProviderNotesByNoteIdActionsSuggestedApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/actions/suggested`,
      }),
    }),
    postV2ProviderNotesByNoteIdCosignAction: build.mutation<
      PostV2ProviderNotesByNoteIdCosignActionApiResponse,
      PostV2ProviderNotesByNoteIdCosignActionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/cosign-action`,
        method: "POST",
        body: queryArg.cosignActionRequest,
      }),
    }),
    postV2ProviderNotesByNoteIdCosignDisposition: build.mutation<
      PostV2ProviderNotesByNoteIdCosignDispositionApiResponse,
      PostV2ProviderNotesByNoteIdCosignDispositionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/cosign-disposition`,
        method: "POST",
        body: queryArg.cosignDispositionRequest,
      }),
    }),
    postV2ProviderNotesByNoteIdRedo: build.mutation<
      PostV2ProviderNotesByNoteIdRedoApiResponse,
      PostV2ProviderNotesByNoteIdRedoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/redo`,
        method: "POST",
      }),
    }),
    postV2ProviderNotesByNoteIdRequestEdits: build.mutation<
      PostV2ProviderNotesByNoteIdRequestEditsApiResponse,
      PostV2ProviderNotesByNoteIdRequestEditsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/request-edits`,
        method: "POST",
        body: queryArg.requestEditsRequest,
      }),
    }),
    postV2ProviderNotesByNoteIdResignDisposition: build.mutation<
      PostV2ProviderNotesByNoteIdResignDispositionApiResponse,
      PostV2ProviderNotesByNoteIdResignDispositionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/resign-disposition`,
        method: "POST",
        body: queryArg.resignDispositionRequest,
      }),
    }),
    postV2ProviderNotesByNoteIdSections: build.mutation<
      PostV2ProviderNotesByNoteIdSectionsApiResponse,
      PostV2ProviderNotesByNoteIdSectionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/sections`,
        method: "POST",
        body: queryArg.addSectionsRequest,
      }),
    }),
    postV2ProviderNotesByNoteIdSectionsReorder: build.mutation<
      PostV2ProviderNotesByNoteIdSectionsReorderApiResponse,
      PostV2ProviderNotesByNoteIdSectionsReorderApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/sections/reorder`,
        method: "POST",
        body: queryArg.reorderSectionsRequest,
      }),
    }),
    deleteV2ProviderNotesByNoteIdSectionsAndSectionId: build.mutation<
      DeleteV2ProviderNotesByNoteIdSectionsAndSectionIdApiResponse,
      DeleteV2ProviderNotesByNoteIdSectionsAndSectionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/sections/${queryArg.sectionId}`,
        method: "DELETE",
      }),
    }),
    patchV2ProviderNotesByNoteIdSectionsAndSectionIndex: build.mutation<
      PatchV2ProviderNotesByNoteIdSectionsAndSectionIndexApiResponse,
      PatchV2ProviderNotesByNoteIdSectionsAndSectionIndexApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/sections/${queryArg.sectionIndex}`,
        method: "PATCH",
        body: queryArg.editSectionRequest,
      }),
    }),
    postV2ProviderNotesByNoteIdSectionsAndSectionIndexRevert: build.mutation<
      PostV2ProviderNotesByNoteIdSectionsAndSectionIndexRevertApiResponse,
      PostV2ProviderNotesByNoteIdSectionsAndSectionIndexRevertApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/sections/${queryArg.sectionIndex}/revert`,
        method: "POST",
      }),
    }),
    getV2ProviderNotesByNoteIdSignedPdf: build.query<
      GetV2ProviderNotesByNoteIdSignedPdfApiResponse,
      GetV2ProviderNotesByNoteIdSignedPdfApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/signed-pdf`,
      }),
    }),
    patchV2ProviderNotesByNoteIdTemplate: build.mutation<
      PatchV2ProviderNotesByNoteIdTemplateApiResponse,
      PatchV2ProviderNotesByNoteIdTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/template`,
        method: "PATCH",
        body: queryArg.updateNoteTemplateRequest,
      }),
    }),
    postV2ProviderNotesByNoteIdUndo: build.mutation<
      PostV2ProviderNotesByNoteIdUndoApiResponse,
      PostV2ProviderNotesByNoteIdUndoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/notes/${queryArg.noteId}/undo`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type PostV2AdminNotesWorkflowsEditNoteApiResponse =
  /** status 200 OK */ WorkflowResponse;
export type PostV2AdminNotesWorkflowsEditNoteApiArg = {
  editNoteRequest: EditNoteRequest;
};
export type GetV2AdminNotesWorkflowsStatusByTaskIdApiResponse =
  /** status 200 OK */ WorkflowStatusResponse;
export type GetV2AdminNotesWorkflowsStatusByTaskIdApiArg = {
  taskId: string;
};
export type GetV2AdminNotesByNoteIdApiResponse =
  /** status 200 OK */ AdminNoteDetailResponse;
export type GetV2AdminNotesByNoteIdApiArg = {
  noteId: string;
};
export type PostV2AdminNotesByNoteIdGeneratePdfApiResponse =
  /** status 200 OK */ GenerateNotePdfResponse;
export type PostV2AdminNotesByNoteIdGeneratePdfApiArg = {
  noteId: string;
};
export type GetV2AdminProvidersByProviderIdNotesApiResponse =
  /** status 200 OK */ ListResponseAdminNoteListItem;
export type GetV2AdminProvidersByProviderIdNotesApiArg = {
  providerId: string;
};
export type PostV2ProviderNoteGenerationCustomizeApiResponse =
  /** status 200 OK */ CustomizeModuleResponse;
export type PostV2ProviderNoteGenerationCustomizeApiArg = {
  customizeModuleRequest: CustomizeModuleRequest;
};
export type PostV2ProviderNoteGenerationCustomizeApplyByThreadIdApiResponse =
  /** status 200 OK */ ApplyCustomizationResponse;
export type PostV2ProviderNoteGenerationCustomizeApplyByThreadIdApiArg = {
  threadId: string;
  applyCustomizationRequest: ApplyCustomizationRequest;
};
export type GetV2ProviderNoteGenerationCustomizeHistoryByThreadIdApiResponse =
  /** status 200 OK */ CustomizeModuleHistoryResponse;
export type GetV2ProviderNoteGenerationCustomizeHistoryByThreadIdApiArg = {
  threadId: string;
};
export type PostV2ProviderNoteGenerationGenerateApiResponse =
  /** status 200 OK */ GenerateModuleTextResponse;
export type PostV2ProviderNoteGenerationGenerateApiArg = {
  generateModuleTextRequest: GenerateModuleTextRequest;
};
export type GetV2ProviderNoteGenerationStreamByThreadIdApiResponse = unknown;
export type GetV2ProviderNoteGenerationStreamByThreadIdApiArg = {
  threadId: string;
};
export type GetV2ProviderNoteProcessingWorkflowsStatusByThreadIdApiResponse =
  /** status 200 OK */ ProcessingStatusResponse;
export type GetV2ProviderNoteProcessingWorkflowsStatusByThreadIdApiArg = {
  threadId: string;
};
export type GetV2ProviderNoteProcessingWorkflowsStreamByThreadIdApiResponse =
  unknown;
export type GetV2ProviderNoteProcessingWorkflowsStreamByThreadIdApiArg = {
  threadId: string;
};
export type GetV2ProviderNotesApiResponse =
  /** status 200 OK */ ListResponseNoteListItemResponse;
export type GetV2ProviderNotesApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Scope to org notes (supervisor queue) */
  organizationId?: string | null;
  /** Filter to a server-defined actionable note queue. */
  queue?: NoteQueueFilter | null;
  /** Filter by completion status. Accepts a single value (e.g. 'completed') or comma-separated values (e.g. 'completed,signed'). */
  completionStatus?: string | null;
  /** Text search on note title and content */
  search?: string | null;
  /** Restrict search to note title only */
  noteTitleOnly?: boolean;
  /** Unix timestamp lower bound for time_uploaded */
  startDate?: string | null;
  /** Unix timestamp upper bound for time_uploaded */
  endDate?: string | null;
  /** Sort direction: 1 ascending, -1 descending */
  sortOrder?: SortOrder;
  /** Set to 'mine' (with organization_id) to scope the queue to the caller's supervisees: members assigned to them plus unassigned members who need co-signing. Requires the supervisor role. */
  cosignScope?: string | null;
  /** Include dismissed/snoozed items for queue views. Supported by cosign_scope=mine and queue=reopened_needing_resign. */
  includeDismissed?: boolean;
};
export type PostV2ProviderNotesWorkflowsEditNoteApiResponse =
  /** status 200 OK */ WorkflowResponse;
export type PostV2ProviderNotesWorkflowsEditNoteApiArg = {
  providerEditNoteRequest: ProviderEditNoteRequest;
};
export type GetV2ProviderNotesWorkflowsStatusByTaskIdApiResponse =
  /** status 200 OK */ WorkflowStatusResponse;
export type GetV2ProviderNotesWorkflowsStatusByTaskIdApiArg = {
  taskId: string;
};
export type PostV2ProviderNotesBulkCosignApiResponse =
  /** status 200 OK */ BulkCosignResponse;
export type PostV2ProviderNotesBulkCosignApiArg = {
  bulkCosignRequest: BulkCosignRequest;
};
export type GetV2ProviderNotesByNoteIdApiResponse =
  /** status 200 OK */ NoteResponse;
export type GetV2ProviderNotesByNoteIdApiArg = {
  noteId: string;
};
export type PatchV2ProviderNotesByNoteIdApiResponse =
  /** status 200 OK */ NoteResponse;
export type PatchV2ProviderNotesByNoteIdApiArg = {
  noteId: string;
  updateNoteRequest: UpdateNoteRequest;
};
export type GetV2ProviderNotesByNoteIdActionsSuggestedApiResponse =
  /** status 200 OK */ ActionListResponse;
export type GetV2ProviderNotesByNoteIdActionsSuggestedApiArg = {
  noteId: string;
};
export type PostV2ProviderNotesByNoteIdCosignActionApiResponse =
  /** status 200 OK */ CosignActionResponse;
export type PostV2ProviderNotesByNoteIdCosignActionApiArg = {
  noteId: string;
  cosignActionRequest: CosignActionRequest;
};
export type PostV2ProviderNotesByNoteIdCosignDispositionApiResponse =
  /** status 200 OK */ CosignDispositionResponse;
export type PostV2ProviderNotesByNoteIdCosignDispositionApiArg = {
  noteId: string;
  cosignDispositionRequest: CosignDispositionRequest;
};
export type PostV2ProviderNotesByNoteIdRedoApiResponse =
  /** status 200 OK */ NoteResponse;
export type PostV2ProviderNotesByNoteIdRedoApiArg = {
  noteId: string;
};
export type PostV2ProviderNotesByNoteIdRequestEditsApiResponse =
  /** status 200 OK */ RequestEditsResponse;
export type PostV2ProviderNotesByNoteIdRequestEditsApiArg = {
  noteId: string;
  requestEditsRequest: RequestEditsRequest;
};
export type PostV2ProviderNotesByNoteIdResignDispositionApiResponse =
  /** status 200 OK */ ResignDispositionResponse;
export type PostV2ProviderNotesByNoteIdResignDispositionApiArg = {
  noteId: string;
  resignDispositionRequest: ResignDispositionRequest;
};
export type PostV2ProviderNotesByNoteIdSectionsApiResponse =
  /** status 201 Created */ NoteResponse;
export type PostV2ProviderNotesByNoteIdSectionsApiArg = {
  noteId: string;
  addSectionsRequest: AddSectionsRequest;
};
export type PostV2ProviderNotesByNoteIdSectionsReorderApiResponse =
  /** status 200 OK */ NoteResponse;
export type PostV2ProviderNotesByNoteIdSectionsReorderApiArg = {
  noteId: string;
  reorderSectionsRequest: ReorderSectionsRequest;
};
export type DeleteV2ProviderNotesByNoteIdSectionsAndSectionIdApiResponse =
  /** status 200 OK */ NoteResponse;
export type DeleteV2ProviderNotesByNoteIdSectionsAndSectionIdApiArg = {
  noteId: string;
  sectionId: string;
};
export type PatchV2ProviderNotesByNoteIdSectionsAndSectionIndexApiResponse =
  /** status 200 OK */ EditSectionResponse;
export type PatchV2ProviderNotesByNoteIdSectionsAndSectionIndexApiArg = {
  noteId: string;
  sectionIndex: number;
  editSectionRequest: EditSectionRequest;
};
export type PostV2ProviderNotesByNoteIdSectionsAndSectionIndexRevertApiResponse =
  unknown;
export type PostV2ProviderNotesByNoteIdSectionsAndSectionIndexRevertApiArg = {
  noteId: string;
  sectionIndex: number;
};
export type GetV2ProviderNotesByNoteIdSignedPdfApiResponse = unknown;
export type GetV2ProviderNotesByNoteIdSignedPdfApiArg = {
  noteId: string;
};
export type PatchV2ProviderNotesByNoteIdTemplateApiResponse =
  /** status 200 OK */ NoteResponse;
export type PatchV2ProviderNotesByNoteIdTemplateApiArg = {
  noteId: string;
  updateNoteTemplateRequest: UpdateNoteTemplateRequest;
};
export type PostV2ProviderNotesByNoteIdUndoApiResponse =
  /** status 200 OK */ NoteResponse;
export type PostV2ProviderNotesByNoteIdUndoApiArg = {
  noteId: string;
};
export type WorkflowResponse = {
  /** Current status */
  status: string;
  /** Task ID for tracking */
  task_id: string;
  /** Thread ID for state management */
  thread_id: string;
  /** Name of the workflow */
  workflow_name: string;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type EditNoteRequest = {
  /** Note ID to edit */
  note_id: string;
  /** Organization ID */
  organization_id?: string | null;
  /** Provider ID for context gathering */
  provider_id: string;
  /** Text input for editing */
  text: string;
};
export type WorkflowStatusResponse = {
  /** Error message if failed */
  error?: string | null;
  /** Whether the task is complete */
  ready: boolean;
  /** Task result if successful */
  result?: any | null;
  /** Task status (PENDING, SUCCESS, FAILURE, etc) */
  status: string;
  /** Whether the task succeeded */
  successful?: boolean | null;
  /** Task ID */
  task_id: string;
};
export type AdminAppointmentSummary = {
  appointment_id: string;
  duration?: number | null;
  encounter_type?: string | null;
  encounter_type_id?: string | null;
  modality?: string | null;
  organization_id?: string | null;
  patient_id?: string | null;
  start_time?: string | null;
  status?: string | null;
  telehealth?: boolean | null;
  title?: string | null;
  use_jotmeet?: boolean | null;
};
export type AdminEncounterSummary = {
  appointment_id?: string | null;
  created_at?: string | null;
  encounter_id: string;
  encounter_type?: string | null;
  input_documents?: number | null;
  patient_id?: string | null;
  status?: string | null;
  updated_at?: string | null;
};
export type AdminNoteDetail = {
  created_at?: string | null;
  encounter_id?: string | null;
  encounter_type?: string | null;
  has_feedback?: boolean | null;
  note_id: string;
  organization_id?: string | null;
  patient_id?: string | null;
  patient_name?: string | null;
  provider_id?: string | null;
  status?: string | null;
  template?: string | null;
  updated_at?: string | null;
};
export type AdminNoteProcessingSessionSummary = {
  created_at?: string | null;
  note_id?: string | null;
  note_processing_session_id: string;
  status?: string | null;
  transcription_session_ids?: string[] | null;
};
export type AdminProviderSummary = {
  email?: string | null;
  last_login_time?: string | null;
  name?: string | null;
  organization_id?: string | null;
  organization_name?: string | null;
  provider_id: string;
  role?: string | null;
};
export type AdminTranscriptionSummary = {
  chunk_count?: number | null;
  created_at?: string | null;
  is_closed?: boolean | null;
  job_status?: string | null;
  notes_created?: number | null;
  start_time?: string | null;
  transcription_session_id: string;
};
export type AdminNoteDetailResponse = {
  appointment?: AdminAppointmentSummary | null;
  encounter?: AdminEncounterSummary | null;
  note: AdminNoteDetail;
  note_processing_sessions: AdminNoteProcessingSessionSummary[];
  provider: AdminProviderSummary;
  transcriptions: AdminTranscriptionSummary[];
};
export type GenerateNotePdfResponse = {
  /** Path where the PDF was saved */
  file_path: string;
  /** Size of the generated PDF file in bytes */
  file_size_bytes: number;
  /** The note ID */
  note_id: string;
  /** Whether PDF generation succeeded */
  success: boolean;
};
export type AdminNoteListItem = {
  created_at: string;
  encounter_id?: string | null;
  encounter_type?: string | null;
  has_feedback: boolean;
  note_id: string;
  patient_id?: string | null;
  status: string;
  template: string;
  transcript_id?: string | null;
};
export type ListResponseAdminNoteListItem = {
  items: AdminNoteListItem[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type CustomizeModuleResponse = {
  /** Processing status */
  status: string;
  /** URL to connect for SSE streaming */
  stream_url: string;
  /** Celery task ID for tracking */
  task_id: string;
  /** Thread ID for this operation */
  thread_id: string;
};
export type CustomizeModuleRequest = {
  /** ID of the encounter */
  encounter_id?: string | null;
  /** Feedback to improve the generation prompt */
  feedback: string;
  /** Optional partial module updates (e.g., {'generation_prompt': 'xxx'}) */
  module?: {
    [key: string]: any;
  } | null;
  /** ID of the module to customize */
  module_id?: string | null;
  /** ID of the note containing context */
  note_id?: string | null;
  /** ID of the template (schema_version 2) */
  template_id?: string | null;
  /** Optional template_prompt_md override (for mode 2, when frontend provides updated prompt) */
  template_prompt_md?: string | null;
  /** Optional thread ID for conversation context */
  thread_id?: string | null;
};
export type ApplyCustomizationResponse = {
  /** Version number that was applied */
  applied_version: number;
  /** Module ID (may be new if forked from public module) */
  module_id: string;
  /** New module version number in database */
  module_version: number;
  /** Original module ID if it was forked (only present if forked) */
  previous_module_id?: string | null;
};
export type ApplyCustomizationRequest = {
  /** Version number to apply (defaults to latest/current version) */
  version?: number | null;
};
export type CustomizeModuleHistoryResponse = {
  /** Current version number */
  current_version: number;
  /** Module ID being customized */
  module_id: string;
  /** Thread ID for this conversation */
  thread_id: string;
  /** Complete history of all versions with prompts, explanations, and examples */
  version_history: {
    [key: string]: any;
  }[];
};
export type GenerateModuleTextResponse = {
  /** Processing status */
  status: string;
  /** URL to connect for SSE streaming */
  stream_url: string;
  /** Celery task ID for tracking */
  task_id: string;
  /** Thread ID for this operation */
  thread_id: string;
};
export type GenerateModuleTextRequest = {
  /** ID of the encounter */
  encounter_id?: string | null;
  /** Optional partial module updates (e.g., {'generation_prompt': 'xxx'}) */
  module?: {
    [key: string]: any;
  } | null;
  /** ID of the module to generate text for */
  module_id?: string | null;
  /** ID of the note containing context */
  note_id?: string | null;
  /** ID of the template (schema_version 2) */
  template_id?: string | null;
  /** Optional thread ID for conversation context */
  thread_id?: string | null;
};
export type WorkflowStepInfo = {
  /** Human-readable step name */
  display_name: string;
  /** Step identifier */
  id: string;
  /** Step order (0-indexed) */
  order: number;
};
export type ProcessingStatusResponse = {
  /** List of completed step IDs */
  completed_steps?: string[];
  /** ID of the currently executing step */
  current_step?: string | null;
  /** Human-readable name of current step */
  current_step_display_name?: string | null;
  /** Associated encounter ID */
  encounter_id?: string | null;
  /** Associated note ID */
  note_id?: string | null;
  /** Current status: pending, processing, completed, error */
  status: string;
  /** Full list of workflow steps (visible only) with metadata */
  steps?: WorkflowStepInfo[];
  /** Thread ID for the workflow */
  thread_id: string;
  /** Total number of visible steps */
  total_steps?: number;
  /** Name of the workflow being executed */
  workflow_name?: string | null;
};
export type CosignBillingLineResponse = {
  /** Charge amount in cents */
  charge_cents?: number | null;
  /** CPT or HCPCS code without its system prefix */
  code: string;
  /** Billing modifiers */
  modifiers?: string[];
  /** Billed units */
  units?: number;
};
export type CosignBillingDetailsResponse = {
  /** ICD-10 diagnosis codes */
  diagnosis_codes?: string[];
  /** Procedure lines */
  line_items?: CosignBillingLineResponse[];
  /** CMS place-of-service code */
  place_of_service?: string | null;
};
export type CosignDispositionState = {
  /** Epoch seconds when dismissed */
  dismissed_at?: number | null;
  /** Supervisor who set the disposition */
  dismissed_by?: string | null;
  /** Epoch seconds the snooze lasts until */
  snoozed_until?: number | null;
};
export type NoteReopenInfo = {
  /** Display name of the user who reopened */
  name: string;
  /** Unix timestamp of the reopen */
  reopened_at: number;
  /** ID of the user who reopened the note */
  user_id: string;
};
export type NotePreviewSectionResponse = {
  /** Section text */
  text?: string;
  /** Section title */
  title?: string;
};
export type ResignDispositionState = {
  dismissed_at?: number | null;
  dismissed_by?: string | null;
  snoozed_until?: number | null;
};
export type ReviewCommentResponse = {
  /** Comment text */
  comment: string;
  /** ISO timestamp of when comment was created */
  created_at: string;
  /** ID of the commenter */
  user_id: string;
  /** Name of the commenter */
  user_name: string;
};
export type SignatureEntryResponse = {
  /** License number */
  license_number?: string | null;
  /** License state */
  license_state?: string | null;
  /** License/credential type (e.g. MD, LCSW, PhD) */
  license_type?: string | null;
  /** Signer name at time of signing */
  name: string;
  /** NPI number */
  npi_number?: string | null;
  /** Role: 'author' or 'supervisor' */
  role: string;
  /** ISO timestamp of signing */
  signed_at: string;
  /** ID of the signer */
  user_id: string;
};
export type NoteListItemResponse = {
  /** Billing facts associated with the encounter */
  billing_details?: CosignBillingDetailsResponse | null;
  /** Note completion status */
  completion_status?: string | null;
  /** When the note was completed */
  completion_timestamp?: number | null;
  /** Dismiss/snooze state for the cosign queue, if any */
  cosign_disposition?: CosignDispositionState | null;
  /** True when the note's author needs co-signing but has no assigned supervisor, so the item appears in every supervisor's scoped queue. Only populated for cosign_scope=mine queries. */
  cosign_unassigned?: boolean;
  /** High-level encounter analysis summary */
  encounter_analysis_summary?: string | null;
  /** A small set of encounter analysis tags for review */
  encounter_analysis_tags?: string[];
  /** Whether note is signed */
  is_signed?: boolean;
  /** ID of the note author */
  issuing_user_id: string;
  /** Name of the note author */
  issuing_user_name?: string | null;
  /** Who most recently reopened this signed/submitted note. */
  last_reopened?: NoteReopenInfo | null;
  /** Note ID */
  note_id: string;
  /** Note title */
  note_title?: string;
  /** Organization ID */
  organization_id?: string | null;
  /** Patient ID */
  patient_id?: string | null;
  /** Patient full name */
  patient_name?: string | null;
  /** Up to three signed note sections for queue review */
  preview_sections?: NotePreviewSectionResponse[];
  /** Whether this note requires co-signature */
  requires_cosigning?: boolean;
  /** Dismiss/snooze state for the author's re-sign reminder. */
  resign_disposition?: ResignDispositionState | null;
  /** Review comments from supervisors/billing admins */
  review_comments?: ReviewCommentResponse[];
  /** Resolved date of service for the linked encounter */
  service_date?: string | null;
  /** Signing events */
  signature_metadata?: SignatureEntryResponse[];
  /** Note processing status */
  status?: string;
  /** First section text as a preview */
  summary?: string;
  /** Template name used for this note */
  template_name?: string | null;
  /** Creation timestamp */
  time_uploaded?: number;
};
export type ListResponseNoteListItemResponse = {
  items: NoteListItemResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type NoteQueueFilter = "reopened_needing_resign";
export type SortOrder = 1 | -1;
export type ProviderEditNoteRequest = {
  /** Note ID to edit */
  note_id: string;
  /** Organization ID */
  organization_id?: string | null;
  /** Text input for editing */
  text: string;
};
export type BulkCosignItemResponse = {
  /** For future_date_of_service failures: the encounter's effective date of service (ISO date), so the client can render the offending date without a follow-up read */
  date_of_service?: string | null;
  /** For future_date_of_service failures: calendar days between the author-local today and the date of service */
  days_in_future?: number | null;
  /** Stable failure code when this note could not be signed */
  error_code?: string | null;
  /** Human-readable result message */
  message: string;
  /** The note's new completion status when successful */
  new_status?: string | null;
  /** The note ID */
  note_id: string;
  /** Whether this note was co-signed */
  success: boolean;
};
export type BulkCosignResponse = {
  /** Number of notes not co-signed */
  failed_count: number;
  /** Result for each requested note, in request order */
  results?: BulkCosignItemResponse[];
  /** Number of notes successfully co-signed */
  signed_count: number;
  /** Whether every requested note was co-signed */
  success: boolean;
};
export type BulkCosignRequest = {
  /** Co-sign despite encounters having a materially future date of service (GDN-2784); applies to every note in the request. */
  acknowledge_future_date_of_service?: boolean;
  /** Unique note IDs to co-sign in this request */
  note_ids: string[];
};
export type NoteSection = {
  /** Section context/metadata */
  context?: any | null;
  /** Edited section text */
  edited_text?: string | null;
  /** Edit history */
  edits?: any[] | null;
  /** Error message if generation failed */
  error?: string | null;
  /** Whether section has been rated */
  is_rated?: boolean | null;
  /** Whether section text is markdown-formatted */
  markdown?: boolean | null;
  /** Model used for generation */
  model?: string | null;
  /** Module ID */
  module_id?: string | null;
  /** Section name */
  name: string;
  /** Section priority */
  priority?: number | null;
  /** Section generation version */
  section_generation_version?: number | null;
  /** Section ID */
  section_id: string;
  /** Original section text */
  text: string;
};
export type NoteContent = {
  /** Extra content */
  extras?: any | null;
  /** Note sections */
  sections?: NoteSection[];
};
export type EncounterDocumentReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Encounter document ID */
  encounter_document_id: string;
  /** Output status */
  status?: "pending" | "completed";
  /** Document title for display */
  title?: string | null;
  /** Document type */
  type: "text" | "recording" | "document" | "note";
};
export type JotDocReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** JotDoc ID (None for pending outputs) */
  jotdoc_id?: string | null;
  /** Output status */
  status?: "pending" | "completed";
  /** Task ID for tracking (optional, for debugging) */
  task_id?: string | null;
  /** Thread ID for building SSE stream URL */
  thread_id?: string | null;
  /** Document title */
  title?: string | null;
  /** Document type */
  type?: string;
};
export type EncounterInfo = {
  /** Encounter ID */
  encounter_id: string;
  /** Output documents or notes */
  outputs?: (EncounterDocumentReference | JotDocReference)[];
  /** Whether transcripts have been deleted for this encounter */
  transcripts_deleted?: boolean;
};
export type UserInfo = {
  /** User name */
  name: string;
  /** User ID */
  user_id: string;
};
export type NoteReopenInfo2 = {
  /** Display name of the user who reopened */
  name: string;
  /** Unix timestamp of the reopen */
  reopened_at: number;
  /** ID of the user who reopened the note */
  user_id: string;
};
export type InsuranceSummary = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  /** True if the patient has a phone or email a reminder could be delivered to. None when unknown (patient not fully loaded). */
  reminder_reachable?: boolean | null;
  telephone?: string | null;
};
export type ReviewCommentResponse2 = {
  /** Comment text */
  comment: string;
  /** ISO timestamp of when comment was created */
  created_at: string;
  /** ID of the commenter */
  user_id: string;
  /** Name of the commenter */
  user_name: string;
};
export type SignatureEntryResponse2 = {
  /** License number */
  license_number?: string | null;
  /** License state */
  license_state?: string | null;
  /** License/credential type (e.g. MD, LCSW, PhD) */
  license_type?: string | null;
  /** Signer name at time of signing */
  name: string;
  /** NPI number */
  npi_number?: string | null;
  /** Role: 'author' or 'supervisor' */
  role: string;
  /** ISO timestamp of signing */
  signed_at: string;
  /** ID of the signer */
  user_id: string;
};
export type SuggestionStatus = "not_expected" | "expected" | "ready";
export type TemplatePermissions = {
  /** Whether the user may delete the template. */
  can_delete?: boolean;
  /** Whether the user may edit the template. */
  can_edit?: boolean;
  /** Whether the user may fork the template. */
  can_fork?: boolean;
  /** Whether the user may view the template. */
  can_view?: boolean;
};
export type NoteTemplateInfo = {
  /** Template owner scope: 'public', 'org', or 'user' */
  owner_scope?: string | null;
  /** Template ID */
  template_id?: string | null;
  /** Template name */
  template_name?: string | null;
  /** Computed permissions for the template (can_edit, can_fork, etc.) */
  template_permissions?: TemplatePermissions | null;
  /** Template version used to generate this note */
  template_version?: number | null;
};
export type NoteResponse = {
  /** Whether the note can have context added (based on size) */
  can_add_context: boolean;
  /** Whether the note can be edited */
  can_edit_template: boolean;
  /** Whether the note can be redone to a next version */
  can_redo: boolean;
  /** Whether the note can be regenerated (false if transcripts deleted) */
  can_regenerate: boolean;
  /** Whether JotAudit can be manually triggered (first-time only) */
  can_trigger_jotaudit: boolean;
  /** Whether the note can be undone to a previous version */
  can_undo: boolean;
  /** Note completion status */
  completion_status?: string | null;
  /** When the note was completed (Unix timestamp) */
  completion_timestamp?: number | null;
  /** Note content with sections */
  content: NoteContent;
  /** Current version ID for undo/redo tracking */
  current_version?: string | null;
  /** Associated encounter information */
  encounter?: EncounterInfo | null;
  /** Error message, if any */
  error_message?: string | null;
  /** Whether note has feedback */
  has_feedback?: boolean | null;
  /** Internal note title */
  internal_title?: string | null;
  /** Whether note has been copied */
  is_copied?: boolean | null;
  /** Whether note has been rated */
  is_rated?: boolean | null;
  /** Whether note is signed */
  is_signed?: boolean | null;
  /** User who created the note */
  issuing_user: UserInfo;
  /** Set while the note is reopened ('reviewing') after having been signed/submitted; identifies who reopened it and when. Cleared when the note is completed or re-signed. */
  last_reopened?: NoteReopenInfo2 | null;
  /** Note ID */
  note_id: string;
  /** Note title */
  note_title?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Associated patient information */
  patient?: PatientInfo | null;
  /** Patient ID */
  patient_id?: string | null;
  /** Whether this note requires co-signature from a supervisor */
  requires_cosigning?: boolean;
  /** Review comments from supervisors/billing admins */
  review_comments?: ReviewCommentResponse2[];
  /** Section generation status (processing/completed) */
  sections_status?: string | null;
  /** Resolved date of service for the linked encounter (resolve_encounter_service_date waterfall). The canonical date to show/copy for this note; the billing day, not the upload/recording time. */
  service_date?: string | null;
  /** Signing events with denormalized credentials */
  signature_metadata?: SignatureEntryResponse2[];
  /** Note status */
  status: string;
  /** ISO-8601 UTC instant by which an 'expected' suggestion should have landed. Null unless suggestion_status is 'expected'. Past this point the suggestion is late, not necessarily lost. */
  suggestion_expected_by?: string | null;
  /** Whether AI-suggested billing codes are on the encounter's working_billing_claim ('ready'), currently being generated ('expected'), or will never arrive without a manual trigger ('not_expected'). Drive a bounded poll of the encounter off 'expected'; do not poll on the other two. */
  suggestion_status?: SuggestionStatus | null;
  /** Template info */
  template?: NoteTemplateInfo | null;
  /** Combined text from encounter documents and provided context */
  text_notes_string?: string | null;
  /** Thread ID for SSE streaming */
  thread_id?: string | null;
  /** DEPRECATED — use `uploaded_at` (same value). When the note was uploaded/created; not a date of service. */
  time_uploaded?: number | null;
  /** Transcript data */
  transcript?: any[] | null;
  /** Transcription end time */
  transcription_end_timestamp?: number | null;
  /** Transcription length in seconds */
  transcription_length_seconds?: number | null;
  /** Transcription start time */
  transcription_start_timestamp?: number | null;
  /** When the note was uploaded/created. An upload timestamp, not the date of service; use the encounter's `service_date` for that. */
  uploaded_at?: number | null;
};
export type FutureDateOfServiceErrorResponse = {
  /** The encounter's effective date of service (ISO date) */
  date_of_service: string;
  /** Calendar days between today (author-local) and the date */
  days_in_future: number;
  /** Stable error code for the guard */
  error_code?: string;
  /** Human-readable message */
  message?: string;
  /** The HTTP status code */
  status?: number;
};
export type NoteCompletionStatus =
  | "reviewing"
  | "completed"
  | "ready"
  | "edits_requested"
  | "signed";
export type UpdateNoteRequest = {
  /** Complete the note despite its encounter having a materially future date of service (GDN-2784). Resend with this flag after the client confirms the 409 future_date_of_service response. */
  acknowledge_future_date_of_service?: boolean;
  /** New completion status (reviewing or completed) */
  completion_status?: NoteCompletionStatus | null;
  /** Mark note as copied */
  is_copied?: boolean | null;
  /** New note title */
  note_title?: string | null;
};
export type InsuranceSummary2 = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Display-ready coverage label, e.g. payer name or Self-pay */
  display_label?: string | null;
  /** Group/employer number */
  group_number?: string | null;
  /** True when the patient is explicitly designated self-pay */
  is_self_pay?: boolean;
  /** Coverage kind: insurance, self_pay, other */
  kind?: string;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo2 = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary2[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  /** True if the patient has a phone or email a reminder could be delivered to. None when unknown (patient not fully loaded). */
  reminder_reachable?: boolean | null;
  telephone?: string | null;
};
export type ActionResponse = {
  action_id: string;
  action_payload: {
    [key: string]: any;
  };
  action_type: string;
  created_at: string;
  encounter_id: string | null;
  patient?: PatientInfo2 | null;
  provider_id: string;
  state: string;
  updated_at: string;
};
export type ActionListResponse = {
  items: ActionResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type CosignActionResponse = {
  /** Human-readable result message */
  message: string;
  /** The new completion status of the note */
  new_status: string;
  /** The note ID */
  note_id: string;
  /** Whether the action was successful */
  success: boolean;
};
export type CosignAction = "sign" | "request_edits";
export type CosignActionRequest = {
  /** Co-sign despite the encounter having a materially future date of service (GDN-2784). Resend with this flag after confirming the 409 future_date_of_service response. */
  acknowledge_future_date_of_service?: boolean;
  /** The action to perform: 'sign' to co-sign, 'request_edits' to request changes */
  action: CosignAction;
  /** Review comment when requesting edits (ignored for 'sign' action) */
  comment?: string | null;
};
export type CosignDispositionAction = "dismiss" | "snooze" | "clear";
export type CosignDispositionState2 = {
  /** Epoch seconds when dismissed */
  dismissed_at?: number | null;
  /** Supervisor who set the disposition */
  dismissed_by?: string | null;
  /** Epoch seconds the snooze lasts until */
  snoozed_until?: number | null;
};
export type CosignDispositionResponse = {
  /** The action performed */
  action: CosignDispositionAction;
  /** The stored disposition after the action (null if cleared) */
  cosign_disposition?: CosignDispositionState2 | null;
  /** The note ID */
  note_id: string;
  /** Whether the action was successful */
  success: boolean;
};
export type CosignDispositionAction2 = "dismiss" | "snooze" | "clear";
export type CosignDispositionRequest = {
  /** 'dismiss' hides the note from scoped cosign queues, 'snooze' hides it until snooze_until, 'clear' restores it. Never waives the cosign requirement. */
  action: CosignDispositionAction2;
  /** Epoch seconds to snooze until (required for 'snooze') */
  snooze_until?: number | null;
};
export type RequestEditsResponse = {
  /** Human-readable result message */
  message: string;
  /** The new completion status of the note */
  new_status: string;
  /** The note ID */
  note_id: string;
  /** Whether the action was successful */
  success: boolean;
};
export type RequestEditsRequest = {
  /** Review comment explaining what edits are needed */
  comment?: string | null;
};
export type ResignDispositionAction = "dismiss" | "snooze" | "clear";
export type ResignDispositionState2 = {
  dismissed_at?: number | null;
  dismissed_by?: string | null;
  snoozed_until?: number | null;
};
export type ResignDispositionResponse = {
  action: ResignDispositionAction;
  note_id: string;
  resign_disposition?: ResignDispositionState2 | null;
  success: boolean;
};
export type ResignDispositionAction2 = "dismiss" | "snooze" | "clear";
export type ResignDispositionRequest = {
  action: ResignDispositionAction2;
  /** Epoch seconds to snooze until (required for 'snooze') */
  snooze_until?: number | null;
};
export type AddSectionsRequest = {
  /** Position to insert sections (0-based index) */
  insert_index: number;
  /** List of module IDs to generate sections from */
  module_ids: string[];
};
export type ReorderSectionsRequest = {
  /** Ordered list of section IDs defining the new order */
  sections: string[];
};
export type EditSectionResponse = {
  diff: any[];
};
export type EditSectionRequest = {
  /** The new edited text for the section */
  edited_text: string;
};
export type NoteTemplateSectionRequest = {
  content: string;
  /** Preview of what this section generates */
  example_output?: string | null;
  id: string;
  order?: number;
  title: string;
};
export type UpdateNoteTemplateRequest = {
  allow_user_forks?: boolean | null;
  description?: string | null;
  prompt?: string | null;
  sections?: NoteTemplateSectionRequest[] | null;
  title?: string | null;
};
